
define('text!widgets/balance/view.html',[],function () { return '<div class="balance-widget color-green pad-small" data-bind="nav: ROUTES.DEPOSIT">\n    <div class="icon" />\n    <div>\n        <b>{{playerBalanceAmount}}</b>\n    </div>\n</div>\n';});

